import { useMemo } from "react";
import { FormControl, Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { getCountryOptions, getStateOptions } from "../../utils/address";
import TextField from "../TextField";
import SingleSelect from "../SingleSelect";

export interface IAddress {
  t: any;
  language: string;
  data: any;
  onChange: (address: string) => void;
  required?: boolean;
  error?: any;
}

export default ({ t, language, data, onChange, required, error }: IAddress) => {
  const theme = useTheme();
  const onUpdate = (e: any) => {
    onChange(JSON.stringify({ ...data, [e.target.name]: e.target.value }));
  };
  const onUpdateCountry = (e: any) => {
    onChange(
      JSON.stringify({ ...data, [e.target.name]: e.target.value, state: "" }),
    );
  };

  const countryOptions = useMemo(() => getCountryOptions(t), [language]);

  const stateOptions: any = useMemo(() => getStateOptions(t), [language]);

  const getError = (
    error: any,
    value: string,
    requiredMsg?: string,
    maxChars: number = 100,
  ) => {
    if (error) {
      if (error === "REQUIRED" && requiredMsg && (!value || value.length < 1)) {
        return requiredMsg;
      } else if (error === "MAX_ADDRESS_LENGTH" && value.length > maxChars) {
        return t("AddressMaxAllowedLength", { count: maxChars });
      }
    } else {
      return null;
    }
  };

  return (
    <Grid
      container
      xs={12}
      sx={{
        position: "relative",
        border: "1px solid #CCCCCC",
        m: 2,
        p: 1,
        borderRadius: "8px",
      }}
    >
      <Typography
        component="span"
        sx={{
          position: "absolute",
          top: "-13px",
          left: "27px",
          pl: "5px",
          pr: "5px",
          backgroundColor: theme.palette.background.paper,
          fontSize: "14px",
          color: "text.secondary",
        }}
      >
        {t("Address")}
      </Typography>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6} sx={{ p: 2 }}>
        <FormControl size="small" fullWidth>
          <TextField
            name="address1"
            label={t("AddressLine1")}
            placeholder={t("AddressLine1")}
            // required={required ? true : false}
            value={data.address1}
            onChange={onUpdate}
            error={
              !!getError(error, data.address1, t("AddressLine1IsRequired"))
            }
            helperText={getError(
              error,
              data.address1,
              t("AddressLine1IsRequired"),
            )}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6} sx={{ p: 2 }}>
        <FormControl size="small" fullWidth>
          <TextField
            name="address2"
            label={t("AddressLine2")}
            placeholder={t("AddressLine2")}
            // required={required ? true : false}
            value={data.address2}
            onChange={onUpdate}
            // error={!!error && !data.address2}
            // helperText={
            //   !!error && !data.address2 && t("AddressLine2IsRequired")
            // }
            error={!!getError(error, data.address2)}
            helperText={getError(error, data.address2)}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={4} xl={4} sx={{ p: 2 }}>
        <FormControl size="small" fullWidth>
          <TextField
            name="city"
            label={t("AddressCity")}
            placeholder={t("AddressCity")}
            // required={required ? true : false}
            value={data.city}
            onChange={onUpdate}
            // error={!!error && !data.city}
            // helperText={!!error && !data.city && t("AddressCityIsRequired")}
            error={!!getError(error, data.city, t("AddressCityIsRequired"), 30)}
            helperText={getError(
              error,
              data.city,
              t("AddressCityIsRequired"),
              30,
            )}
          />
        </FormControl>
      </Grid>
      {/* <Grid item xs={12} sm={6} md={4} lg={4} xl={4} sx={{ p: 2 }}>
        <FormControl size="small" fullWidth >
          <TextField
            name="state"
            size="small"
            label={t("AddressState")}
            placeholder={t("AddressState")}
            required={required ? true : false}
            value={data.state}
            onChange={onUpdate}
          />
        </FormControl>
      </Grid> */}

      <Grid item xs={12} sm={6} md={4} lg={4} xl={4} sx={{ p: 2 }}>
        <FormControl size="small" fullWidth>
          <SingleSelect
            name="country"
            label={t("AddressCountry")}
            // required={required}
            value={data.country}
            options={[
              { label: `--${t("SelectCountry")}--`, value: "" },
              ...countryOptions,
            ]}
            onChange={onUpdateCountry}
            // error={!!error && !data.country}
            // helperText={!!error && !data.country && t("AddressCountryIsRequired")}
            error={
              !!getError(error, data.country, t("AddressCountryIsRequired"), 30)
            }
            helperText={getError(
              error,
              data.country,
              t("AddressCountryIsRequired"),
              30,
            )}
          />
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={4} xl={4} sx={{ p: 2 }}>
        <FormControl size="small" fullWidth>
          {data.country === "IN" ? (
            <SingleSelect
              name="state"
              label={t("AddressState")}
              // required={required}
              value={data.state}
              options={[
                { label: `--${t("SelectState")}--`, value: "" },
                ...stateOptions,
              ]}
              onChange={onUpdate}
              // error={!!error && !data.state}
              // helperText={!!error && !data.state && t("AddressStateIsRequired")}
              error={
                !!getError(error, data.state, t("AddressStateIsRequired"), 30)
              }
              helperText={getError(
                error,
                data.state,
                t("AddressStateIsRequired"),
                30,
              )}
            />
          ) : (
            <TextField
              name="state"
              label={t("AddressState")}
              placeholder={t("AddressState")}
              // required={true}
              value={data.state}
              onChange={onUpdate}
              // error={!!error && !data.state}
              // helperText={
              //   !!error && !data.state && t("AddressStateIsRequired")
              // }
              error={
                !!getError(error, data.state, t("AddressStateIsRequired"), 10)
              }
              helperText={getError(
                error,
                data.state,
                t("AddressStateIsRequired"),
                10,
              )}
            />
          )}
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={4} xl={4} sx={{ p: 2 }}>
        <FormControl size="small" fullWidth>
          <TextField
            name="pincode"
            label={t("AddressPincode")}
            placeholder={t("AddressPincode")}
            // required={true}
            value={data.pincode}
            onChange={onUpdate}
            // error={!!error && !data.pincode}
            // helperText={
            //   !!error && !data.pincode && t("AddressPincodeIsRequired")
            // }
            error={
              !!getError(error, data.pincode, t("AddressPincodeIsRequired"), 10)
            }
            helperText={getError(
              error,
              data.pincode,
              t("AddressPincodeIsRequired"),
              10,
            )}
          />
        </FormControl>
      </Grid>
    </Grid>
  );
};
